import React, {
  useCallback, useEffect, useRef, useState,
} from 'react';

import cn from 'classnames';
import { useSelector } from 'react-redux';

import {
  getImportPanelVisibility, setImportPanelVisibility, isInbox, commentShow, titleShow, marksShow, customFieldsShow,
} from './helpers';
import { isUploadStarted as isUploadStartedSelector } from '../../store/import/selectors';

import Placeholder from './Placeholder';
import Header from './Header';
import Comment from './Comment';
import TitleAndDescription from './TitleAndDescription';
import AssetMarks from './AssetMarks';
import CustomFields from './CustomFields';
import picsioConfig from '../../../../../config';

import './styles.scss';

/** @NOTE: Used require just for conditional import */
const Keywords = isInbox ? () => { } : require('./Keywords').default;
const Assignees = isInbox ? () => { } : require('./Assignees').default;

const AdditionalFields = () => {
  const [panelsVisibility, setPanelsVisibility] = useState(getImportPanelVisibility());
  const prevErrorsCount = useRef(0);
  const showPlaceholder = useSelector((state) => !state.import.selected.length);
  const isUploadStarted = useSelector(isUploadStartedSelector);
  const errors = useSelector((state) => state.import.errors);

  const $holder = useRef();
  const $comment = useRef();
  const $title = useRef();
  const $keywords = useRef();
  const $assignees = useRef();
  const $marks = useRef();
  const $customFields = useRef();

  useEffect(() => {
    const errorsCount = Object.keys(errors).length;
    if (prevErrorsCount.current === 0 && errorsCount > 0) {
      /** If errors appeared */
      const {
        assetMarks,
        assignees,
        comment,
        description,
        keywords,
        customFields,
        title,
      } = errors;
      const block = (() => {
        if (comment) return $comment.current;
        if (title || description) return $title.current;
        if (keywords) return $keywords.current;
        if (assignees) return $assignees.current;
        if (assetMarks) return $marks.current;
        if (customFields) return $customFields.current;
        return null;
      })();

      if (block) {
        if (window.innerWidth < 1024) {
          const $importContent = document.querySelector('.importContent');
          if ($importContent) $importContent.scrollTop = block.offsetTop;
        } else {
          $holder.current.scrollTop = block.offsetTop - 20;
        }
      }
    }
    prevErrorsCount.current = errorsCount;
  }, [errors]);

  const toggleVisibility = useCallback((title) => {
    setPanelsVisibility((prevValue) => {
      const newValue = { ...prevValue, [title]: !prevValue[title] };
      setImportPanelVisibility(newValue);
      return newValue;
    });
  }, [setPanelsVisibility]);

  return (
    <div className={cn('importAdditionalFields', { disabled: isUploadStarted })}>
      <div className="importFieldsHolder" ref={$holder}>
        <Choose>
          <When condition={showPlaceholder}>
            <Placeholder />
          </When>
          <Otherwise>
            <Header />
            {/* Comment */}
            <If condition={commentShow}>
              <Comment
                ref={$comment}
                panelsVisibility={panelsVisibility}
                toggleVisibility={toggleVisibility}
              />
            </If>
            {/* Title and description  */}
            <If condition={titleShow}>
              <TitleAndDescription
                ref={$title}
                panelsVisibility={panelsVisibility}
                toggleVisibility={toggleVisibility}
              />
            </If>
            <If condition={!isInbox}>
              {/* Keywords */}
              <Keywords
                ref={$keywords}
                panelsVisibility={panelsVisibility}
                toggleVisibility={toggleVisibility}
              />
              {/* Assignees */}
              <Assignees
                ref={$assignees}
                panelsVisibility={panelsVisibility}
                toggleVisibility={toggleVisibility}
              />
            </If>
            <If condition={marksShow}>
              {/* Asset Marks */}
              <AssetMarks
                ref={$marks}
                panelsVisibility={panelsVisibility}
                toggleVisibility={toggleVisibility}
              />
            </If>
            <If condition={customFieldsShow}>
              {/* Custom Fields */}
              <CustomFields
                ref={$customFields}
                panelsVisibility={panelsVisibility}
                toggleVisibility={toggleVisibility}
              />
            </If>
          </Otherwise>
        </Choose>
      </div>
    </div>
  );
};

export default AdditionalFields;
